import * as moment from 'moment';
import { CampaignQCCall, ViewCampaignQCCall } from 'app/common/services/SmartQC.service';

export function buildViewCampaignQCCalls(campaignQCCalls: CampaignQCCall[], rowIndex: number): ViewCampaignQCCall[] {
  return campaignQCCalls.map((campaignQCCall, index) => {
    const startTime = campaignQCCall.call_analyze ? campaignQCCall.call_analyze.startTime : null;
    const duration = campaignQCCall.call_analyze ? campaignQCCall.call_analyze.analyze_data.duration : null;
    const scriptName = campaignQCCall.call_analyze ? campaignQCCall.call_analyze.analyze_data.qcScriptName : null;
    const emotionCustomer = campaignQCCall.call_analyze
      ? campaignQCCall.call_analyze.analyze_data.emotionCustomer
      : null;

    const emotionAgent = campaignQCCall.call_analyze ? campaignQCCall.call_analyze.analyze_data.emotionAgent : null;
    const endCallStatus = campaignQCCall.call_analyze ? campaignQCCall.call_analyze.analyze_data.endcallStatus : null;
    const qcScorePercent = campaignQCCall.call_analyze ? campaignQCCall.call_analyze.analyze_data.qcScorePercent : null;
    const qcStatus = campaignQCCall.call_analyze ? campaignQCCall.call_analyze.analyze_data.qcStatus : null;
    const qcCategory = campaignQCCall.call_analyze ? campaignQCCall.call_analyze.analyze_data.qcCategory : null;

    return {
      ...campaignQCCall,
      index: rowIndex + index + 1,
      display_agentName: campaignQCCall.agent ? campaignQCCall.agent.name : '',
      display_startTime: getDisplayStartTime(startTime, duration),
      display_scriptName: getDisplayQCScriptName(scriptName),
      display_emotionCustomer: getDisplayContentEmotionCustomerColumn(emotionCustomer),
      display_emotionAgent: getDisplayContentEmotionAgentColumn(emotionAgent),
      display_endCallStatus: getDisplayContentEndCallStatusColumn(endCallStatus),
      display_qcPercent: getDisplayQCScorePercent(qcScorePercent),
      display_qcStatus: getDisplayContentQCStatusColumn(qcStatus),
      display_qcCategory: getDisplayQCCategoryColumn(qcCategory),
    };
  });
}

export function buildTableColumns() {
  return [
    {
      title: 'STT',
      key: 'index',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Chuyên viên',
      key: 'display_agentName',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Thời gian',
      key: 'display_startTime',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Kịch bản',
      key: 'display_scriptName',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Thái độ khách hàng',
      key: 'display_emotionCustomer',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Thái độ chuyên viên',
      key: 'display_emotionAgent',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Trạng thái',
      key: 'display_endCallStatus',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Điểm chuyên viên',
      key: 'display_qcPercent',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Trạng thái chấm điểm',
      key: 'display_qcStatus',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Phân loại chuyên viên',
      key: 'display_qcCategory',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
  ];
}

export function getDisplayContentEmotionCustomerColumn(emotionCustomer?: string) {
  switch (emotionCustomer) {
    case 'Anger':
      return emotionCustomer;
    case 'UnHappy':
      return '<div class="block-column block-error">UnHappy</div>';
    case 'MidPriority':
      return 'MidPriority';
    case 'Normal':
      return '<div class="block-column block-success">Normal</div>';
    default:
      return '';
  }
}

export function getDisplayContentEmotionAgentColumn(emotionAgent?: string) {
  switch (emotionAgent) {
    case 'Anger':
      return 'Anger';
    case 'UnHappy':
      return '<div class="block-column block-error">UnHappy</div>';
    case 'MidPriority':
      return 'MidPriority';
    case 'Normal':
      return '<div class="block-column block-success">Normal</div>';
    default:
      return '';
  }
}

export function getDisplayContentEndCallStatusColumn(endCallStatus?: string) {
  return !endCallStatus ? '' : endCallStatus;
}

export function getDisplayContentQCStatusColumn(qcStatus?: string) {
  return !qcStatus ? '' : qcStatus;
}

export function getDisplayQCCategoryColumn(qcCategory?: string) {
  return !qcCategory ? '' : qcCategory;
}

export function getDisplayQCScriptName(qcSCriptName?: string) {
  return !qcSCriptName ? '' : qcSCriptName;
}

export function getDisplayStartTime(startTime?: string, duration?: number) {
  if (!startTime && !duration) return '';

  const startTimeFormat = moment(startTime).format('YYYY-MM-DD HH:mm:ss');
  // const durationFormat = new Date(duration * 1000).toISOString().substring(11, 8);

  return `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2;">
      <p>${startTimeFormat || ''}</p>
    </div>
  `;
}

export function getDisplayQCScorePercent(qcScorePercent?: number) {
  return !qcScorePercent ? '' : `${qcScorePercent}%`;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/campaign/campaign-detail/campaign-detail.util.ts